/**
 * Note to developers: Because all of the login actions sync with initialization (isInitialized = true), all redux store state needs to be hydrated before calling these actions.
 */
export const reducer = (state, action) => {
  switch (action.type) {
    case 'NO_USER':
      return {
        ...state,
        user: undefined,
        isInitialized: true,
      }
    case 'LOGIN':
      return {
        ...state,
        user: action.user,
        isInitialized: true,
      }
    case 'LOGOUT':
      return {
        ...state,
        user: undefined,
        isInitialized: true,
      }
    case 'SET_ERROR':
      return {
        ...state,
        error: action.error,
      }
    case 'CLEAR_ERROR':
      return {
        ...state,
        error: undefined,
      }
  }
}
